import { useEffect, useRef, useState } from "react";
import * as Ably from "ably";
import { ventrisConfig } from '../ventris.config';

export function useAbly(testId?: string | number) {
  const clientRef = useRef<Ably.Realtime | null>(null);
  const [status, setStatus] = useState<"initialized"|"connecting"|"connected"|"disconnected"|"suspended"|"closing"|"closed"|"failed">("initialized");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const client = new Ably.Realtime({
          authCallback: async (tokenParams, callback) => {
            try {
              const tokenRequest = await getAblyTokenRequest(testId);
              callback(null, tokenRequest);
            } catch (err: any) {
              callback(err, null);
            }
          },
        });
        client.connection.on((stateChange) => {
          if (cancelled) {
            return;
          }
          const currentState = stateChange.current as typeof status;
          setStatus(currentState);
          console.info("[realtime] connection_state", {
            previous: stateChange.previous,
            current: stateChange.current,
            connectionId: client.connection.id,
            reason: stateChange.reason?.message,
            errorCode: stateChange.reason?.code,
          });
        });
        clientRef.current = client;
      } catch (error) {
        if (!cancelled) {
          setStatus("failed");
          console.error("[realtime] client_initialization_failed", error);
        }
      }
    })();
    
    return () => {
      cancelled = true;
      clientRef.current?.close();
    };
  }, [testId]);

  const getAblyTokenRequest = async (requestedTestId?: string | number) => {
    let token = sessionStorage.getItem("token");
    const testQuery = requestedTestId === undefined || requestedTestId === null || requestedTestId === ''
      ? ''
      : '?test_id=' + encodeURIComponent(String(requestedTestId));
    const response = await fetch(ventrisConfig.url + '/api/realtime/token' + testQuery, {
      headers: {
        "Authorization": "Bearer " + token,
      },
    });

    if (!response.ok) {
      console.error("[realtime] token_request_failed", { status: response.status });
      throw new Error("Failed to fetch Ably token!");
    }

    return await response.json();
  }

  return { ably: clientRef.current, status };
}
